export default {
  login: "Anmeldung",
  loginTo: "Anmeldung bei",
  resetPassword: "Passwort zurücksetzen",
  magic_link_expired: "Der Link ist abgelaufen",
  magic_link_expired_subtitle:
    "Möchten Sie einen neuen Link per E-Mail erhalten oder sich mit Ihrem Passwort anmelden?",
  reconnect: "Anmelden",
  send_magic_link: "Link erneut senden",
  magic_link_sent: "Ein neuer Link wurde per E-Mail gesendet",
  magic_link_error: "Ups, der neue Link konnte nicht generiert werden.",
  reconnect_error: "Gesicherter Bereich",
  reconnect_error_message: "Bitte geben Sie Ihr Passwort ein, um auf diesen Bereich der Website zuzugreifen",
  loginMobile: "Bitte geben Sie Ihre Kennung oder Ihre E-Mail ein, um sich anzumelden",
  loading: "Laden...",
  password: "Passwort",
  reinitialize: "Zurücksetzen",
  username: "Kennung",
  organization: "Einrichtung",
  showPassword: "Passwort anzeigen",
  keepMeLoggedIn: "Angemeldet bleiben",
  forgotPasswordLink: "Passwort vergessen?",
  loginValidation: "Bitte geben Sie Ihre Anmeldedaten ein",
  loginLoginValidation: "Bitte geben Sie Ihre Kennung oder Ihre E-Mail ein",
  loginPasswordValidation: "Bitte geben Sie Ihr Passwort ein",
  alertIdentify: "Sie sind angemeldet",
  alertIdentifyError: "Fehler bei der Anmeldung",
  logout: "Abmelden",
  badCredentials: "Falsche Anmeldedaten",
  password_reset_info: "Bitte geben Sie Ihre Kennung oder Ihre E-Mail ein, um Ihr Passwort zurückzusetzen",
  reset_password: "Passwort vergessen",
  reset_password_confirm: "Ein Link zur Erstellung eines neuen Passworts wurde an Ihr Postfach gesendet",
  new_password_confirm: "Ihr Passwort wurde erfolgreich aktualisiert!",
  reset_link_expired: "Dieser Link ist nicht mehr gültig. Bitte fordern Sie einen neuen an.",
  reset_link_expired_forgot: "Der von Ihnen verwendete Link ist abgelaufen. Sie können unten einen neuen anfordern.",
  reset_link_welcome_title: "Willkommen!",
  reset_link_expired_welcome:
    "Ihr Konto ist jetzt aktiviert. Klicken Sie unten, um eine neue E-Mail zur Festlegung Ihres Passworts zu erhalten.",
  reset_link_renew_action: "Link erneuern",
  reset_link_welcome_action: "Passwort festlegen",
  reset_link_renew_sent: "Ihnen wurde ein neuer Link per E-Mail zugesandt.",
  reset_link_renew_error: "Ein Fehler ist aufgetreten, bitte versuchen Sie es erneut.",
  new_password: "Neues Passwort",
  not_available: "Nicht verfügbar",
  accessAccountDenied: "Sie haben keinen Zugang zur Anwendung mit diesem Konto",
  legal_notice: "Rechtliche Hinweise",
  personal_data: "Persönliche Daten",
  release_notes: "Versionshinweise",
  learner_privacy: "Persönliche Daten: Alternant",
  professional_tutor_privacy: "Persönliche Daten: Beruflicher Betreuer",
  pedagogic_tutor_privacy: "Persönliche Daten - Ausbildungseinrichtungen",
  contact_us: "Kontakt",
  contact_help: "Hilfe",
  terms_and_conditions: "Nutzungsbedingungen",
  password_confirm: "Passwortbestätigung",
  password_error: "Beide Passwörter müssen identisch sein",
  login_presentation: "Was ist das digitale Heft",
  login_in_progress: "Anmeldung läuft",
  expired_session: "Sitzung abgelaufen",
  stay_connected_question: "Möchten Sie angemeldet bleiben?",
  stay_connected_confirm: "Angemeldet bleiben",
  session_disconnected_message: "Sie wurden aufgrund langer Inaktivität abgemeldet.",
  second_password_not_valid: "Beide Passwörter müssen identisch sein",
  password_not_valid: "Das Passwortformat ist ungültig",
  "Personal data - Confidentiality": "Persönliche Daten - Datenschutz",
  "Since May 25, 2018, the entry into force of the General Data Protection Regulation has been amended; regulations on personal data.":
    "Seit dem 25. Mai 2018 ist die Datenschutz-Grundverordnung in Kraft getreten; die Vorschriften zum Schutz personenbezogener Daten wurden geändert.",
  "We invite you to read the information notices below. The origin, purpose and processing carried out on the data collected by Studea depend, ... according to the profile of each user.":
    "Wir laden Sie ein, die nachstehenden Informationshinweise zu lesen. Der Ursprung, der Zweck und die Verarbeitung der von Studea erhobenen Daten hängen je nach Benutzerprofil ab.",
  "We offer 3 notices here, depending on your user profile, we invite you to read the one that corresponds to your case":
    "Wir bieten hier 3 Hinweise an. Je nach Ihrem Benutzerprofil laden wir Sie ein, denjenigen zu lesen, der Ihrem Fall entspricht",
  "You are a work-study student and you have been registered on the platform by your training organization":
    "Sie sind ein Alternant und wurden von Ihrer Ausbildungseinrichtung auf der Plattform registriert",
  "Personal data - Confidentiality (Alternate access)": "Persönliche Daten - Datenschutz (Alternant-Zugang)",
  "You are an employee of a company and you supervise a work-study program as a Tutor":
    "Sie sind Mitarbeiter/in eines Unternehmens und betreuen ein/e Alternant/e als Betreuer/in",
  "Personal data - Confidentiality (apprenticeship masters and company tutor)":
    "Persönliche Daten - Datenschutz (Ausbildungsmeister und Unternehmensbetreuer)",
  "You are an employee of a training organization, you administratively manage training courses or you supervise young people as an educational tutor":
    "Sie sind Mitarbeiter/in einer Ausbildungseinrichtung, verwalten administrativ Ausbildungen oder betreuen junge Menschen als pädagogischer Betreuer/in",
  "Personal data - Confidentiality (Employees of training organizations, educational tutor)":
    "Persönliche Daten - Datenschutz (Mitarbeiter der Ausbildungseinrichtungen, pädagogischer Betreuer)",
};
